import { createContext, Dispatch, SetStateAction } from "react";
import { AxiosRequestConfig } from "axios";

interface IGlobalContext {
  controller: AbortController,
  setAxiosConfig: Dispatch<SetStateAction<(
    AxiosRequestConfig
  ) | undefined>>,
  axiosResult?: any,
  axiosError?: unknown,
  isGlobalLoading?: boolean,
  setGlobalLoading?: Dispatch<SetStateAction<boolean>>,
}

const GlobalContext = createContext<IGlobalContext>({
  setAxiosConfig: () => { /** */ },
  controller: new AbortController(),
});

export default GlobalContext;
